import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const header = document.querySelector("#adv-header");
    header.scrollIntoView({
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}
